<p-accordion id="accordion" [multiple]="false">
  <p-accordionTab>
    <ng-template pTemplate="header">
      <span>{{ 'PRODUCTO.LBL_CONFIGURACION_DEL' | translate }}<strong> {{ 'PRODUCTO.LBL_PAZO_DIAS' | translate }}</strong></span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-producto-plazos [producto]="producto" [isDetail]="isDetail"></app-producto-plazos>
    </ng-template>
  </p-accordionTab>

  <p-accordionTab>
    <ng-template pTemplate="header">
      <span>{{ 'PRODUCTO.LBL_CONFIGURACION_DE' | translate }}<strong> {{ 'PRODUCTO.LBL_MONTOS_SALARIO' | translate }}</strong></span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-producto-montos [producto]="producto" [isDetail]="isDetail"></app-producto-montos>
    </ng-template>
  </p-accordionTab>

  <p-accordionTab [cache]="false">
    <ng-template pTemplate="header">
      <span>{{ 'PRODUCTO.LBL_CONFIGURACION_DE' | translate }}<strong> {{ 'PRODUCTO.LBL_MONTOS_PLAZOS' | translate }}</strong></span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-producto-montos-plazos [producto]="producto" [isDetail]="isDetail"></app-producto-montos-plazos>
    </ng-template>
  </p-accordionTab>
</p-accordion>
